module.exports = __webpack_public_path__ + "static/logo-95c2ab09086b697c84c9c015e4ae6bc1.png";